import {
  ORDER_METHODS,
  SMART_PRICING_MODIFIER_TYPE,
  SMART_PRICING_RESOURCE_TYPE,
} from '../../../../../services/exports/Constants';

export default {
  title: {
    [SMART_PRICING_RESOURCE_TYPE.company]: '{{name}} — règle globale de tarification intelligente',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: '{{name}} — règle maître de tarification intelligente',
    [SMART_PRICING_RESOURCE_TYPE.menu]: '{{name}} — règle de tarification intelligente du menu',
    [SMART_PRICING_RESOURCE_TYPE.category]: '{{name}} — règle de tarification intelligente de la catégorie',
    [SMART_PRICING_RESOURCE_TYPE.product]: '{{name}} — règle de tarification intelligente du produit',
    [SMART_PRICING_RESOURCE_TYPE.modifier_group]:
      '{{name}} — règle de tarification intelligente du groupe de modificateurs',
    [SMART_PRICING_RESOURCE_TYPE.modifier]: '{{name}} — règle de tarification intelligente du modificateur',
  },
  labels: {
    new: 'Nouveau',
    base_price: 'Prix de base {{name}} : {{value}}',
  },
  form: {
    resource: {
      [SMART_PRICING_RESOURCE_TYPE.menu]: 'Menu',
      [SMART_PRICING_RESOURCE_TYPE.category]: 'Catégorie',
      [SMART_PRICING_RESOURCE_TYPE.product]: 'Produit',
      [SMART_PRICING_RESOURCE_TYPE.modifier_group]: 'Groupe de modificateurs',
      [SMART_PRICING_RESOURCE_TYPE.modifier]: 'Modificateur',
      placeholder: 'Sélectionner {{resource}}',
    },
    order_methods: {
      label: 'Méthodes de commande',
      placeholder: "Sélectionner les méthodes de commande auxquelles la règle s'applique",
      options: {
        [ORDER_METHODS.pickup]: 'À emporter',
        [ORDER_METHODS.delivery]: 'Livraison',
        [ORDER_METHODS.on_site]: 'Commande à table',
      },
    },
    modifier_type: {
      label: 'Type de modificateur de prix',
      placeholder: 'Sélectionner le type de modificateur de prix',
      disabled_tooltip:
        "La valeur absolue n'est pas disponible pour les règles couvrant l'ensemble du menu car elle écraserait le prix de chaque article.",
      tooltip: {
        title: 'Le type de modificateur définit la façon dont les prix sont modifiés',
        description: {
          [SMART_PRICING_MODIFIER_TYPE.absolute]:
            'Absolu : remplace le prix de la ressource par la valeur du modificateur spécifiée',
          [SMART_PRICING_MODIFIER_TYPE.percentage]:
            'Pourcentage : ajoute/soustrait la valeur en pourcentage du modificateur au/du prix de base de la ressource selon le signe de la valeur',
          [SMART_PRICING_MODIFIER_TYPE.fixed_value]:
            'Valeur fixe : ajoute/soustrait la valeur fixe du modificateur au/du prix de base selon le signe de la valeur',
        },
      },
      options: {
        [SMART_PRICING_MODIFIER_TYPE.absolute]: 'Absolu',
        [SMART_PRICING_MODIFIER_TYPE.percentage]: 'Pourcentage',
        [SMART_PRICING_MODIFIER_TYPE.fixed_value]: 'Valeur fixe',
      },
    },
    modifier_value: {
      label: 'Valeur du modificateur de prix',
    },
    round: {
      label: 'Arrondir le prix résultant',
      tooltip:
        'Arrondit le prix résultant à la dizaine supérieure (ex. : 14,91, 14,93, 14,99 deviennent 15,00). Surtout utile pour les règles en pourcentage',
    },
    is_visible: {
      label: 'Afficher comme offre au client',
    },
    name: {
      label: 'Nom',
      placeholder: 'Saisir un nom convivial',
      default: '{{value}} de réduction sur {{resource}}',
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    changes_got_saved: 'Modifications enregistrées',
  },
};
